import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {DeclaracaoSaudePerguntasViewModel} from 'src/app/api/model/conta/proposta-externa/declaracao-saude/declaracaoSaudePerguntasVM';
import {DeclaracaoSaudeViewModel} from 'src/app/api/model/conta/proposta-externa/declaracao-saude/declaracaoSaudeVM';
import {ListaBeneficiariosViewModel} from 'src/app/api/model/conta/proposta-externa/declaracao-saude/listaBeneficiariosVM';
import {EnumService} from 'src/app/api/module/erp/services/area-logada/enum/enum.service';
import {
  TipoPropostaEnum,
  TipoPropostaEnumDescription,
} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {AtualizacaoForcadaService} from 'src/app/api/module/erp/shared/services/atualizacao-forcada-service.service';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {DecalaracaoSaudePropostaService} from 'src/app/api/module/externo/services/proposta/declaracao-saude.proposta.service';
import {PerguntasDecalaracaoSaudeService} from 'src/app/api/module/externo/services/proposta/perguntas-declaracao-saude.service';
import {ScrollService} from 'src/app/components/helper/service/scroll/scroll.service';

@Component({
  selector: 'app-perguntas-declaracao-saude',
  templateUrl: './perguntas-declaracao-saude.component.html',
  styleUrls: ['./perguntas-declaracao-saude.component.scss'],
})
export class PerguntasDeclaracaoSaudeComponent implements OnInit, OnChanges {
  @Input() tipoProposta: TipoPropostaEnum;
  @Input() nome!: string;
  @Input() aniversario!: string;
  @Input() estadoCivil!: string;
  @Input() ehMasculino!: boolean;
  @Input() idade!: number;
  @Input() qtdPerguntasFormAtual!: number;
  @Input() listaDeBeneficiarios = new Array<any>();
  @Input() listaDeRespostasBeneficiarios = new ListaBeneficiariosViewModel();
  @Input() ultimaPerguntaRespondida = new DeclaracaoSaudeViewModel();
  @Input() currentQuestionIndex: number = 0;
  @Input() ehColaborador: boolean = false;
  @Input() dependentInclusion: boolean | null = null;
  @Input() somenteLeituraStep: boolean = false;
  @Output() adicionarNaListaFinal = new EventEmitter<any>();
  @Output() concluirRetornoDS = new EventEmitter<any>();

  declaracaoSaudeVM = new DeclaracaoSaudeViewModel();
  formPerguntas!: FormGroup;
  mostrarEvento: boolean = false;
  PesoEAltura: boolean = false;
  ehAltura: boolean = false;
  ehPeso: boolean = false;
  ehIMC: boolean = false;
  imc!: string | null;
  imcClassificacao!: string;
  proposalId!: string;
  listaDataEvento = new Array<any>();
  isFormSubmited: boolean = false;
  formTouched: boolean = false;
  idResposta: string | null = null;
  altura!: number;
  peso!: number | null;
  idBeneficiario!: string;
  perguntasDeclaracaoSaude = new Array<DeclaracaoSaudePerguntasViewModel>();
  voltarPerguntas: boolean = false;
  indexAtualizado: boolean = false;
  textoDaPergunta!: string;
  imgDaPergunta!: string;
  descricaoDaPergunta!: string;
  indexDaListaDePerguntas!: number;
  caracteresDigitados: number = 0;
  botoesSelecionados: boolean[] = [];
  listaDeRespostaDoBeneficiario = new Array<any>();
  listaCids = new Array<any>();
  listaCidsPorCampo: {[key: number]: any[]} = {};
  formArraysColaborador: FormGroup[] = [];
  mostrarEventoColaborador: boolean[] = [];
  estadoBotoesCPT: {
    [questionIndex: number]: {[eventIndex: number]: string | null};
  } = {};
  estadoBotoesExibirDS: {
    [questionIndex: number]: {[eventIndex: number]: string | null};
  } = {};
  dadosRecebidos = new Array<any>();
  itemTermo: any;
  ehDependente!: string;
  ehTitular!: string;
  mostrarIMC: boolean = false;
  respostasRetornadasDS = new Array();
  retornoDS: boolean = true;
  inbilitarBtnDisplayDS: {[pergunta: number]: {[evento: number]: boolean}} = {};

  constructor(
    public formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _decalaracaoSaudePropostaService: DecalaracaoSaudePropostaService,
    private cdr: ChangeDetectorRef,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private _atualizacaoForcadaService: AtualizacaoForcadaService,
    private _spinnerService: SpinnerService,
    private _scrollService: ScrollService,
    private _perguntasDecalaracaoSaudeService: PerguntasDecalaracaoSaudeService,
    private _errorLogging: ErrorLoggingService,
    private _enumService: EnumService,
  ) {}

  ngOnInit(): void {
    this.buscarPerguntas();
    this.criarFormulario();
    this.buscarEnums();
    this._atualizacaoForcadaService.atualizacaoForcadaDSColaboradorSubject$.subscribe(async () => {
      this.receberDadosCompartilhadoDependente();
      this.buscarPerguntasColaborador(this.dadosRecebidos[0].questionario, this.dadosRecebidos[0].campoObsGs);
    });

    this._atualizacaoForcadaService.atualizacaoForcadaRetornoDSSubject$.subscribe(async () => {
      this.receberDadosCompartilhadoDependente();
      this.receberPerguntasRetornoDS(this.dadosRecebidos);
    });

    this._atualizacaoForcadaService.atualizacaoForcadaRetornoDSProximaPerguntaSubject$.subscribe(async () => {
      this.proximaPerguntaRetornoDS();
    });

    this._atualizacaoForcadaService.atualizacaoForcadaRetornoDSVoltarPerguntaSubject$.subscribe(async () => {
      this.voltarPerguntaRetornoDS();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['currentQuestionIndex'] &&
      (this.currentQuestionIndex === null || this.currentQuestionIndex === undefined)
    ) {
      this.currentQuestionIndex = 0;
    }
    if (!this.ehColaborador) {
      if (this.somenteLeituraStep) {
        this.formPerguntas && this.formPerguntas.disable({emitEvent: false});
        this.listaEventos && this.listaEventos.disable();
      } else {
        this.formPerguntas && this.formPerguntas.enable({emitEvent: true});
      }
    }
  }

  criarFormulario() {
    this.formPerguntas = this.formBuilder.group(
      {
        response: new FormControl(null, [Validators.required]),
        weight: new FormControl('', [Validators.required]),
        height: new FormControl('', [Validators.required]),
        listaEventos: this.formBuilder.array([]),
        optionForPreExistingIllnesses: new FormControl([null, Validators.required]),
        obsGs: new FormControl(null, [Validators.maxLength(3000)]),
      },
      {validators: this.validarEventosObrigatorios()},
    );
  }

  get listaEventos(): FormArray {
    return this.formPerguntas && (this.formPerguntas?.get('listaEventos') as FormArray);
  }

  buscarPerguntas() {
    this._perguntasDecalaracaoSaudeService.perguntasDeclaracaoSaude().subscribe(data => {
      this.perguntasDeclaracaoSaude = data && data;
    });
  }

  buscarEnums() {
    this._enumService.getEnumsProposta().subscribe(
      data => {
        const dataEvento = data.find((enumObj: {enumType: string}) => enumObj.enumType === 'AlertTargetEnum');

        this.listaDataEvento = dataEvento?.values || [];
      },
      error => {
        this.toastr.error('Erro ao buscar valores do campo data de evento das perguntas da DS.');
        this._errorLogging.logError(
          'Erro ao buscar lista de enums do campo data de evento das perguntas da DS.',
          error,
        );
      },
    );
  }

  onMostrarEvento() {
    const valorDaResposta = this.formPerguntas.get('response')?.value;
    this.mostrarEvento = valorDaResposta === true;

    if (!this.mostrarEvento) {
      this.limparFormArray(this.listaEventos);
      this.formPerguntas.get('listaEventos')?.reset();
    }
  }

  onAdicionarEvento() {
    this.isFormSubmited = false;

    if (this.listaEventos.length >= 4) {
      this.toastr.warning('Você já adicionou todos os eventos disponíveis.');
      return;
    }

    const novoEvento = this.formBuilder.group({
      eventDate: [null, Validators.required],
      cid: [null],
      cpt: [null],
      reason: [null],
      displayDs: [null],
      descriptionEvent: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(65)]],
    });
    this.listaEventos.push(novoEvento);
  }

  removerEvento(index: number) {
    this.listaEventos.removeAt(index);
  }

  verificarDuplicidade(eventDate: any, index: number) {
    const dataDeEventos = this.listaEventos.controls.map(event => event.get('eventDate')?.value);

    if (dataDeEventos.includes(eventDate) && dataDeEventos.indexOf(eventDate) !== index) {
      this.toastr.warning('Este valor já foi selecionado em outro evento.');
      this.listaEventos.at(index).get('eventDate')?.setValue(null);
    }
  }

  limparFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  validarEventosObrigatorios(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const resposta = formGroup.get('response')?.value;
      const listaEventos = formGroup.get('listaEventos') as FormArray;

      if (resposta === true && listaEventos.length === 0) {
        return {eventosObrigatorios: true};
      }

      if (resposta === true) {
        for (let i = 0; i < listaEventos.length; i++) {
          const evento = listaEventos.at(i);
          if (!evento.get('eventDate')?.value || !evento.get('descriptionEvent')?.value) {
            return {eventosObrigatorios: true};
          }
        }
      }
      return null;
    };
  }

  onChangeIMC(beneficiario?: string) {
    if (beneficiario && !this.altura) this.verificarPreencherFormulario(beneficiario);
    let peso = this.formPerguntas.get('weight')?.value;

    if (peso && this.altura) {
      peso = parseFloat(peso.toString().replace(',', '.'));
      this.peso = peso;
      if (!isNaN(peso) && !isNaN(this.altura)) {
        const alturaMetros = this.altura / 100;
        const imc = peso / (alturaMetros * alturaMetros);
        this.imc = imc.toFixed(2);
        this.ehIMC = true;

        if (imc < 18.5) {
          this.imcClassificacao = 'abaixo do peso.';
        } else if (imc >= 18.5 && imc < 25) {
          this.imcClassificacao = 'com peso normal.';
        } else if (imc >= 25 && imc < 30) {
          this.imcClassificacao = 'com sobrepeso.';
        } else if (imc >= 30 && imc < 35) {
          this.imcClassificacao = 'com obesidade grau 1.';
        } else if (imc >= 35 && imc < 40) {
          this.imcClassificacao = 'com obesidade grau 2.';
        } else {
          this.imcClassificacao = 'com obesidade grau 3 (mórbida).';
        }
      } else {
        this.imc = '';
        this.ehIMC = false;
      }
    } else {
      this.imc = '';
      this.ehIMC = false;
    }

    if (beneficiario) this.verificarSePerguntaDePesoOuAltura();
  }

  preencherFormulario(formularioRespondido?: any) {
    if (formularioRespondido.codeQuestion === this.perguntasDeclaracaoSaude[this.currentQuestionIndex].codeQuestion) {
      this.formPerguntas.patchValue({
        response: formularioRespondido.response,
        height: formularioRespondido.height || '',
        weight: formularioRespondido.weight || '',
      });
    }

    this.limparFormArray(this.listaEventos);

    for (let i = 1; i <= 5; i++) {
      const descricao = formularioRespondido[`descriptionEvent${i}`];
      const dataEvento = formularioRespondido[`eventDate${i}`];

      if (descricao && dataEvento) {
        this.listaEventos.push(
          this.formBuilder.group({
            eventDate: [dataEvento, Validators.required],
            descriptionEvent: [descricao, [Validators.required, Validators.minLength(2), Validators.maxLength(65)]],
            cid: null,
            cpt: null,
            reason: null,
            displayDS: null,
          }),
        );
      }
    }
    this.onMostrarEvento();
  }

  validacaoListaEventos(resposta: boolean) {
    if (resposta) {
      const listaEventosArray = this.listaEventos;

      // Verifica se há eventos preenchidos corretamente
      const hasValidEvent = listaEventosArray.controls.some(control => {
        const {descriptionEvent, eventDate} = control.value;
        return descriptionEvent && eventDate; // Apenas esses dois são obrigatórios no beneficiãrio
      });

      if (!hasValidEvent) {
        this.isFormSubmited = true;
        listaEventosArray.controls.forEach(control => control.markAllAsTouched());
        this.toastr.warning('Para resposta "Sim". Por favor, preencha pelo menos um evento para avançar.');
      }
    }
  }

  atualizarPergunta() {
    if (this.currentQuestionIndex == 9 && this.ehMasculino) {
      //entra quando inicializa o formulario e oculta a pergunta das mamas
      this.perguntasDeclaracaoSaude.forEach((item: any, index) => {
        if (item.codeQuestion === this.currentQuestionIndex + 2) {
          this.indexDaListaDePerguntas = index + 1;
          this.currentQuestionIndex = index;
          this.textoDaPergunta = item.questionText;
          this.imgDaPergunta = item.iconPath;
          this.descricaoDaPergunta = item.description;
        }
      });
    }

    if (this.currentQuestionIndex == 7 && !this.ehMasculino) {
      //entra quando inicializa o formulario e oculta a pergunta dos orgao masculino
      this.perguntasDeclaracaoSaude.forEach((item: any, index) => {
        if (item.codeQuestion === this.currentQuestionIndex + 2) {
          this.indexDaListaDePerguntas = index + 1;
          this.currentQuestionIndex = index;
          this.textoDaPergunta = item.questionText;
          this.imgDaPergunta = item.iconPath;
          this.descricaoDaPergunta = item.description;
        }
      });
    }

    if (this.voltarPerguntas) {
      if (this.voltarPerguntas && this.currentQuestionIndex == 8) {
        // entra para nao quebrar o range de pergunta do codequestion 8 qundo esta voltando
        this.perguntasDeclaracaoSaude.forEach((item: any, index) => {
          if (item.codeQuestion === this.currentQuestionIndex) {
            this.indexDaListaDePerguntas = index + 1;
            this.currentQuestionIndex = index;
            this.textoDaPergunta = item.questionText;
            this.imgDaPergunta = item.iconPath;
            this.descricaoDaPergunta = item.description;
          }
        });
      } else {
        this.perguntasDeclaracaoSaude.forEach((item: any, index) => {
          if (item.codeQuestion === this.currentQuestionIndex) {
            //entra quando volta a pergunta
            this.indexDaListaDePerguntas = index + 1;
            this.currentQuestionIndex = index;
            this.textoDaPergunta = item.questionText;
            this.imgDaPergunta = item.iconPath;
            this.descricaoDaPergunta = item.description;
          }
        });
      }
    } else {
      this.perguntasDeclaracaoSaude?.forEach((item: any, index) => {
        if (item.codeQuestion === this.perguntasDeclaracaoSaude[this.currentQuestionIndex]?.codeQuestion) {
          this.indexDaListaDePerguntas = index + 1;
          this.textoDaPergunta = item.questionText;
          this.imgDaPergunta = item.iconPath;
          this.descricaoDaPergunta = item.description;
        }
      });
    }
    this.cdr.detectChanges();
  }

  onVoltar(idBeneficiario: string) {
    if (this.currentQuestionIndex > 0) {
      const codeQuestionAtual =
        this.perguntasDeclaracaoSaude && this.perguntasDeclaracaoSaude[this.currentQuestionIndex]?.codeQuestion;

      if (codeQuestionAtual !== undefined) {
        this.currentQuestionIndex = codeQuestionAtual - 1;
      }

      this.atualizarCurrentQuestionIndexDaPergunta();
      this.atualizarPergunta();
      this.verificarPreencherFormulario(idBeneficiario);
      this.voltarPerguntas = false;
    }
  }

  atualizarCurrentQuestionIndexDaPergunta() {
    let perguntaDoencaMamaOcultada = this.currentQuestionIndex === 9; //sexo masculino
    let perguntaGravidezOcultada = this.currentQuestionIndex === 25; //sexo masculino
    let perguntaOrgaoMasculinoOcultada = this.currentQuestionIndex === 8; //sexo feminino

    if (this.ehMasculino && perguntaDoencaMamaOcultada && this.voltarPerguntas) {
      this.currentQuestionIndex = 8;
    }

    if (this.ehMasculino && perguntaGravidezOcultada && this.voltarPerguntas) {
      this.currentQuestionIndex = 24;
    }

    if (!this.ehMasculino && perguntaOrgaoMasculinoOcultada && this.voltarPerguntas) {
      this.currentQuestionIndex = 7;
    }
  }

  filtrarPerguntasPorGeneroEIdade(idBeneficiario?: string) {
    if (!this.perguntasDeclaracaoSaude?.length) {
      return;
    }

    const perguntasParaRemoverPorGenero = this.ehMasculino ? [9, 25] : [8];

    this.perguntasDeclaracaoSaude = this.perguntasDeclaracaoSaude.filter(question => {
      return !perguntasParaRemoverPorGenero.includes(question.codeQuestion);
    });

    const totalPerguntas = this.perguntasDeclaracaoSaude.length;
    this.qtdPerguntasFormAtual = totalPerguntas;

    if (this.currentQuestionIndex != 0) {
      this.currentQuestionIndex = this.listaDeRespostasBeneficiarios.titular.length;
    }

    if (this.ehMasculino && this.listaDeRespostasBeneficiarios.titular.length == 9) {
      this.currentQuestionIndex = 9;
    }

    this.atualizarPergunta();
    this.verificarSePerguntaDePesoOuAltura(); // necessario para colocar input ou radio na pergunta

    if (this.perguntasDeclaracaoSaude && this.perguntasDeclaracaoSaude[this.currentQuestionIndex].codeQuestion == 28) {
      //para quando inicializar a tela na pergunta de kg
      let titular = null;
      titular = this.listaDeRespostasBeneficiarios.titular.find((item: any) => item.codeQuestion === 27);
      this.altura = titular.height;
    }
  }

  verificarSePerguntaDePesoOuAltura() {
    let perguntaAtual: any = null;
    let codeQuestionAtual =
      this.perguntasDeclaracaoSaude && this.perguntasDeclaracaoSaude[this.currentQuestionIndex]?.codeQuestion;

    if (this.voltarPerguntas && codeQuestionAtual != 27) {
      perguntaAtual = this.perguntasDeclaracaoSaude && this.perguntasDeclaracaoSaude[this.currentQuestionIndex - 1];
    } else {
      perguntaAtual = this.perguntasDeclaracaoSaude && this.perguntasDeclaracaoSaude[this.currentQuestionIndex];
      this.voltarPerguntas = false;
    }

    if (codeQuestionAtual === 27) {
      this.ehAltura = true;
      this.ehPeso = false;
      this.mostrarEvento = false;
      this.PesoEAltura = true;
      this.ehIMC = false;
    } else if (codeQuestionAtual === 28) {
      this.ehPeso = true;
      this.ehAltura = false;
      this.PesoEAltura = true;
      this.mostrarEvento = false;
      if (this.idade < 18) {
        this.ehIMC = false;
      }
    } else {
      this.PesoEAltura = false;
      this.ehAltura = false;
      this.ehPeso = false;
      this.mostrarEvento = false;
      this.ehIMC = false;
    }
  }

  onAvancar(idBeneficiario: string) {
    try {
      this.iniciarSpinner();
      if (this.somenteLeituraStep) {
        this.formPerguntas.controls['response'].reset();
        const peso = this.formPerguntas.get('weight')?.value;
        this.peso = Number(peso);
        this.mostrarEvento = false;
        this.imc = null;
        this.currentQuestionIndex++;
        this.atualizarPergunta();
        this.verificarPreencherFormulario(idBeneficiario);
        this.pararSpinner();
      } else {
        this.formTouched = true;
        this.isFormSubmited = false;
        this.idBeneficiario = idBeneficiario;
        let respostaPerguntaAtual = this.formPerguntas.controls['response'].value;

        if (respostaPerguntaAtual) {
          this.validacaoListaEventos(respostaPerguntaAtual);
          if (this.isFormSubmited) {
            this.pararSpinner();
            return;
          }
          this.pararSpinner(500);
        }

        const perguntaAtual = this.perguntasDeclaracaoSaude && this.perguntasDeclaracaoSaude[this.currentQuestionIndex];

        if (this.currentQuestionIndex < this.qtdPerguntasFormAtual) {
          this.declaracaoSaudeVM = new DeclaracaoSaudeViewModel();

          const peso = this.formPerguntas.get('weight')?.value;
          const alturaForm = this.formPerguntas.get('height')?.value;
          const listaPerguntaAtual = this.listaEventos.value;

          if (peso) {
            const valorLimpo = peso
              .replace(/[^\d,.-]/g, '')
              .replace(/\./g, '')
              .replace(',', '.');

            const valorConvertido = parseFloat(valorLimpo);

            if (!isNaN(valorConvertido)) {
              // Arredonda para 2 casas decimais
              this.peso = Math.round(valorConvertido * 100) / 100;
            } else {
              this.peso = 0;
            }
          }

          if (perguntaAtual.codeQuestion == 27) {
            if (!alturaForm) {
              this.pararSpinner();
              this.toastr.warning('Responda a pergunta antes de avançar');
              return;
            }
          } else if (perguntaAtual.codeQuestion == 28) {
            if (!this.peso) {
              this.pararSpinner(500);
              this.toastr.warning('Responda a pergunta antes de avançar');
              return;
            }
          }

          if (alturaForm > 0) {
            this.altura = Number(alturaForm);
          }

          //necessario para atualizar a pergunta
          this.verificarPreencherFormulario(idBeneficiario);

          this.declaracaoSaudeVM.proposalId = this.proposalId;
          this.declaracaoSaudeVM.codeQuestion = perguntaAtual.codeQuestion;
          this.declaracaoSaudeVM.response = respostaPerguntaAtual;
          this.declaracaoSaudeVM.id = this.idResposta;
          this.declaracaoSaudeVM.height = null;
          this.declaracaoSaudeVM.weight = null;
          this.declaracaoSaudeVM.imc = null;

          if (perguntaAtual.codeQuestion == 27) {
            this.declaracaoSaudeVM.response = false;
            this.declaracaoSaudeVM.height = Number(alturaForm);
          } else if (perguntaAtual.codeQuestion == 28) {
            this.declaracaoSaudeVM.response = false;
            this.declaracaoSaudeVM.weight = Number(peso);
            if (this.idade >= 18) this.declaracaoSaudeVM.imc = Number(this.imc);
          }

          listaPerguntaAtual.forEach((item: any) => {
            if (item.eventDate == 1) {
              this.declaracaoSaudeVM.eventDate1 = item.eventDate;
              this.declaracaoSaudeVM.descriptionEvent1 = item.descriptionEvent;
            } else if (item.eventDate == 2) {
              this.declaracaoSaudeVM.eventDate2 = item.eventDate;
              this.declaracaoSaudeVM.descriptionEvent2 = item.descriptionEvent;
            } else if (item.eventDate == 3) {
              this.declaracaoSaudeVM.eventDate3 = item.eventDate;
              this.declaracaoSaudeVM.descriptionEvent3 = item.descriptionEvent;
            } else if (item.eventDate == 4) {
              this.declaracaoSaudeVM.eventDate4 = item.eventDate;
              this.declaracaoSaudeVM.descriptionEvent4 = item.descriptionEvent;
            }
          });

          const beneficiario = this.listaDeBeneficiarios.find((item: any) => item.name === this.nome);

          if (beneficiario) {
            if (!beneficiario.isDependent) {
              this.declaracaoSaudeVM.holderProposalId = beneficiario.id;
            } else {
              this.declaracaoSaudeVM.dependentProposalId = beneficiario.id;
            }
          }

          this._decalaracaoSaudePropostaService
            .responderPerguntas(this.proposalId, this.declaracaoSaudeVM)
            .pipe(
              finalize(() => {
                this.pararSpinner();
              }),
            )
            .subscribe({
              next: (data: any) => {
                this.formPerguntas.controls['response'].reset();
                this.mostrarEvento = false;
                this.imc = null;
                this.currentQuestionIndex++;
                this.atualizarPergunta();
                this.verificarPreencherFormulario(idBeneficiario);
                this.toastr.toastrConfig.preventDuplicates = true;
                this.toastr.success('Pergunta respondida com sucesso.');
              },
              error: (error: any) => {
                const data = {
                  idProposta: this.proposalId,
                  declaracoSaudeVM: this.declaracaoSaudeVM,
                };
                this.erroSentry('Erro ao avancar', error, 'Erro ao clicar no botao onAvancar da ds.', data);
                this.pararSpinner();
              },
            });

          this.limparFormArray(this.listaEventos);
        } else {
          this.currentQuestionIndex++;
          this.pararSpinner(500);
        }
      }
    } catch (error) {
      this.pararSpinner();
    }
  }

  verificarPreencherFormulario(idBeneficiario: string) {
    if (!this.perguntasDeclaracaoSaude || this.perguntasDeclaracaoSaude.length === 0) {
      return;
    }

    const perguntaAtual = this.perguntasDeclaracaoSaude[this.currentQuestionIndex];
    if (!perguntaAtual) {
      return;
    }

    // 🔹 Verificar respostas do titular
    if (this.listaDeRespostasBeneficiarios?.titular) {
      const titular = this.listaDeRespostasBeneficiarios.titular.find(
        (item: any) => item.holderProposalId === idBeneficiario && item.codeQuestion === perguntaAtual.codeQuestion,
      );

      if (titular) {
        this.idResposta = titular.id;
        if (!this.altura) {
          this.altura = titular.height;
        }
        this.verificarSePerguntaDePesoOuAltura();
        this.preencherFormulario(titular);

        if (this.formPerguntas.controls['weight'].value && titular.codeQuestion == 28) {
          this.onChangeIMC(idBeneficiario);
        }
        return;
      }
    }

    // 🔹 Verificar respostas do dependente
    if (this.listaDeRespostasBeneficiarios?.dependente) {
      const respostasDependente = (this.listaDeRespostasBeneficiarios.dependente as Record<string, any>)[
        idBeneficiario
      ];

      if (respostasDependente && Array.isArray(respostasDependente)) {
        const dependente = respostasDependente.find((item: any) => item.codeQuestion === perguntaAtual.codeQuestion);

        if (dependente) {
          this.idResposta = dependente.id;
          if (dependente.height) {
            this.altura = dependente.height;
          }
          this.verificarSePerguntaDePesoOuAltura();
          this.preencherFormulario(dependente);

          if (this.formPerguntas.controls['weight'].value && dependente.codeQuestion == 28) {
            this.onChangeIMC(idBeneficiario);
          }
          return;
        }
      }
    }

    // 🔹 Caso nenhuma resposta seja encontrada
    this.idResposta = null;
    this.verificarSePerguntaDePesoOuAltura();

    if (this.ehPeso && this.altura) {
      this.formPerguntas.patchValue({height: this.altura});
    }
  }

  getCumprirCPT(questionIndex: number, eventoIndex: number): string | null {
    if (!this.estadoBotoesCPT[questionIndex]) {
      this.estadoBotoesCPT[questionIndex] = {};
    }
    return this.estadoBotoesCPT[questionIndex][eventoIndex] ?? null;
  }

  isBtnDisplayDSDesabilitado(perguntaIndex: number, eventoIndex: number): boolean {
    return this.inbilitarBtnDisplayDS?.[perguntaIndex]?.[eventoIndex] === true;
  }

  selecionarBotaoCPT(perguntaIndex: number, eventoIndex: number, escolha: string | null): void {
    if (!this.estadoBotoesCPT[perguntaIndex]) {
      this.estadoBotoesCPT[perguntaIndex] = {};
    }

    // Toggle se já estiver selecionado
    if (this.estadoBotoesCPT[perguntaIndex][eventoIndex] === escolha) {
      this.estadoBotoesCPT[perguntaIndex][eventoIndex] = null;
    } else {
      this.estadoBotoesCPT[perguntaIndex][eventoIndex] = escolha;
    }

    const eventosArray = this.getEventosArray(perguntaIndex);

    if (eventosArray && eventosArray.at(eventoIndex)) {
      const controleBtnCPT = eventosArray.at(eventoIndex).get('cpt');
      const controleBtnExibirDS = eventosArray.at(eventoIndex).get('displayDs');

      // Garantir que a estrutura de desabilitação existe
      if (!this.inbilitarBtnDisplayDS[perguntaIndex]) {
        this.inbilitarBtnDisplayDS[perguntaIndex] = {};
      }

      if (escolha === 'sim') {
        // 1. Define CPT como true
        controleBtnCPT?.setValue(true);

        // 2. Desabilita o botão Exibir DS
        this.inbilitarBtnDisplayDS[perguntaIndex][eventoIndex] = true;

        // 3. Seta display DS como "sim" automaticamente
        controleBtnExibirDS?.setValue(true);

        // 4. Atualiza o estado visual do botão Exibir DS para "sim"
        if (!this.estadoBotoesExibirDS[perguntaIndex]) {
          this.estadoBotoesExibirDS[perguntaIndex] = {};
        }
        this.estadoBotoesExibirDS[perguntaIndex][eventoIndex] = 'sim';
      } else if (escolha === 'nao') {
        // 1. Define CPT como false
        controleBtnCPT?.setValue(false);

        // 2. Habilita o botão Exibir DS
        this.inbilitarBtnDisplayDS[perguntaIndex][eventoIndex] = false;

        // 3. Mantém o valor atual do display DS (não altera)
      } else {
        // Quando escolha é null (desselecionado)
        controleBtnCPT?.setValue(null);

        // 2. Habilita o botão Exibir DS
        this.inbilitarBtnDisplayDS[perguntaIndex][eventoIndex] = false;

        // 3. Reseta o display DS para null
        controleBtnExibirDS?.setValue(null);

        // 4. Atualiza o estado visual do botão Exibir DS para null
        if (this.estadoBotoesExibirDS[perguntaIndex]) {
          this.estadoBotoesExibirDS[perguntaIndex][eventoIndex] = null;
        }
      }
    }

    this.cdr.detectChanges();
  }
  getExibirDS(perguntaIndex: number, eventoIndex: number): string | null {
    // Primeiro verifica no estado dos botões
    if (this.estadoBotoesExibirDS[perguntaIndex]?.[eventoIndex] !== undefined) {
      return this.estadoBotoesExibirDS[perguntaIndex][eventoIndex];
    }

    // Se não estiver no estado, verifica no formulário
    const eventosArray = this.getEventosArray(perguntaIndex);
    if (eventosArray && eventosArray.at(eventoIndex)) {
      const valor = eventosArray.at(eventoIndex).get('displayDs')?.value;
      if (valor === true) return 'sim';
      if (valor === false) return 'nao';
    }

    return null;
  }
  selecionarBotaoExibirDS(perguntaIndex: number, eventoIndex: number, escolha: string | null): void {
    if (!this.estadoBotoesExibirDS[perguntaIndex]) {
      this.estadoBotoesExibirDS[perguntaIndex] = {};
    }

    if (this.estadoBotoesExibirDS[perguntaIndex][eventoIndex] === escolha) {
      this.estadoBotoesExibirDS[perguntaIndex][eventoIndex] = null;
    } else {
      this.estadoBotoesExibirDS[perguntaIndex][eventoIndex] = escolha;
    }

    const eventosArray = this.getEventosArray(perguntaIndex);
    if (eventosArray && eventosArray.at(eventoIndex)) {
      const controleBtnExibirDS = eventosArray.at(eventoIndex).get('displayDs');
      if (escolha === 'sim') {
        controleBtnExibirDS?.setValue(true);
      } else if (escolha === 'nao') {
        controleBtnExibirDS?.setValue(false);
      } else {
        controleBtnExibirDS?.setValue(null);
      }
      this.gravarEventosColaborador(perguntaIndex);
    }
  }

  contarCaracteres(evento?: Event) {
    if (evento) {
      const target = evento.target as HTMLTextAreaElement;
      this.caracteresDigitados = target.value.length;
    } else {
      const obsGsValue = this.formPerguntas?.get('obsGs')?.value;
      this.caracteresDigitados = obsGsValue ? obsGsValue.length : 0;
    }
  }

  buscarCids(event: any, index: number) {
    //  this.iniciarSpinner();
    let cidDigitado = event.term;

    if (!cidDigitado || cidDigitado.length < 3) {
      this.pararSpinner();
      return;
    }

    this._decalaracaoSaudePropostaService
      .buscarCids(cidDigitado)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe(
        data => {
          this.listaCidsPorCampo[index] = data || [];
        },
        error => {
          this.pararSpinner();
        },
      );
  }

  calculaImc(evento: Event) {
    const input = evento.target as HTMLInputElement;
    this.altura = Number(input.value);

    this.onChangeIMC();
  }

  buscarPerguntasColaborador(listaRespostas: any, campoObs?: string) {
    if (!listaRespostas || listaRespostas.length === 0) {
      return;
    }
    this.listaDeRespostaDoBeneficiario = [];
    this.formArraysColaborador = [];
    this.mostrarEventoColaborador = [];
    this.ehDependente = '';
    this.ehTitular = '';
    this.listaCidsPorCampo = {};
    this.formPerguntas.controls['obsGs'].reset();
    this.caracteresDigitados = 0;
    this.imc = '';

    if (listaRespostas[0].dependentProposalId) {
      this.ehDependente = listaRespostas[0].dependentProposalId;
    } else if (listaRespostas[0].holderProposalId) {
      this.ehTitular = listaRespostas[0].holderProposalId;
    }

    listaRespostas?.forEach((resposta: any, index: number) => {
      const pergunta = this.perguntasDeclaracaoSaude.find(
        itemPergunta => itemPergunta.codeQuestion == resposta.codeQuestion,
      );

      if (pergunta) {
        const respostaFormatada: any = {
          ...resposta,
          pergunta: pergunta.questionText,
        };

        if (resposta.codeQuestion !== 27 && resposta.codeQuestion !== 28) {
          respostaFormatada.respostaColaborador = false;
        }

        this.listaDeRespostaDoBeneficiario.push(respostaFormatada);

        if (resposta.codeQuestion === 27) {
          this.formPerguntas.patchValue({
            height: resposta.height || '',
          });
          this.altura = resposta.height;
        } else if (resposta.codeQuestion === 28) {
          this.formPerguntas.patchValue({
            weight: resposta.weight || '',
          });
          if (resposta.imc) {
            this.onChangeIMC();
            this.mostrarIMC = true;
          }
        } else {
          this.formArraysColaborador[index] = this.formBuilder.group({
            events: this.formBuilder.array([]),
          });

          this.mostrarEventoColaborador[index] = resposta.response;

          if (resposta.response) {
            const eventosArray = this.getEventosArray(index);
            this.estadoBotoesCPT[index] = {};
            this.estadoBotoesExibirDS[index] = {};

            for (let i = 1; i <= 5; i++) {
              const dataEvento = resposta[`eventDate${i}`];
              const descricaoEvento = resposta[`descriptionEvent${i}`];
              const cidId = resposta[`cid${i}Id`];
              const cidData = resposta[`cid${i}`];
              const reason = resposta[`reason${i}`];
              const cpt = resposta[`cpt${i}`];
              const displayDs = resposta[`displayDs${i}`];

              if (dataEvento || descricaoEvento || cidId || cidData || reason) {
                let eventoIndex: any;
                eventoIndex = eventosArray?.length;

                let cidValue: {id: number; description: string; cidCode: string; originalData: any} | null = null;

                if (cidId && cidData) {
                  cidValue = {
                    id: cidId,
                    description: cidData.description,
                    cidCode: cidData.cidCode,
                    originalData: cidData,
                  };
                }

                if (!this.listaCidsPorCampo[eventoIndex]) {
                  this.listaCidsPorCampo[eventoIndex] = [];
                }

                if (
                  cidValue &&
                  !this.listaCidsPorCampo[eventoIndex].some(
                    (existingCid: any) => existingCid.id === (cidValue?.id ?? -1),
                  )
                ) {
                  this.listaCidsPorCampo[eventoIndex].push(cidValue);
                }

                const newEvent = this.formBuilder.group({
                  eventDate: [dataEvento || null, Validators.required],
                  descriptionEvent: [descricaoEvento || null, Validators.required],
                  cid: [cidValue?.id || null, Validators.required],
                  reason: [reason || null, Validators.required],
                  displayDs: [displayDs || null, Validators.required],
                  cpt: [cpt || null, Validators.required],
                });

                eventosArray?.push(newEvent);

                if (cidValue && reason) {
                  this.estadoBotoesCPT[index][eventoIndex] = cpt === true ? 'sim' : cpt === false ? 'nao' : null;
                  this.estadoBotoesExibirDS[index][eventoIndex] =
                    displayDs === true ? 'sim' : displayDs === false ? 'nao' : null;
                } else {
                  this.estadoBotoesCPT[index][eventoIndex] = null;
                  this.estadoBotoesExibirDS[index][eventoIndex] = null;
                }
              }
            }
          }
        }
      }
    });

    const respostaTermo = listaRespostas?.find((itemResposta: any) => itemResposta.codeQuestion == 99);
    if (respostaTermo) {
      this.formPerguntas.patchValue({
        optionForPreExistingIllnesses: respostaTermo.optionForPreExistingIllnesses,
      });
    }
    this.itemTermo = respostaTermo;
    if (campoObs) {
      this.formPerguntas.patchValue({obsGs: campoObs});
      this.contarCaracteres();
    }

    this.cdr.detectChanges();
  }

  gravarEventosColaborador(perguntaIndex: number) {
    const eventosArray = this.getEventosArray(perguntaIndex);

    if (!eventosArray) return;

    eventosArray.controls.forEach(control => {
      control.markAllAsTouched();
    });

    for (let i = 1; i <= 5; i++) {
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`eventDate${i}`] = null;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`descriptionEvent${i}`] = null;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`cid${i}`] = null;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`cid${i}Id`] = null;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`cpt${i}`] = false;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`displayDs${i}`] = false;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`reason${i}`] = null;
    }

    eventosArray.controls.forEach((evento: AbstractControl, index: number) => {
      const eventNumber = index + 1; // eventDate1, eventDate2, etc.
      const eventValues = evento.value;

      const objCid = this.listaCidsPorCampo[index].find((j: any) => {
        return j.id == eventValues.cid;
      });

      this.listaDeRespostaDoBeneficiario[perguntaIndex][`eventDate${eventNumber}`] = eventValues.eventDate;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`descriptionEvent${eventNumber}`] =
        eventValues.descriptionEvent;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`cid${eventNumber}`] = objCid;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`cid${eventNumber}Id`] = eventValues.cid;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`cpt${eventNumber}`] = eventValues.cpt ?? false;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`displayDs${eventNumber}`] = eventValues.displayDs ?? false;
      this.listaDeRespostaDoBeneficiario[perguntaIndex][`reason${eventNumber}`] = eventValues.reason;
    });

    this.respostaColaborador(perguntaIndex);
  }

  onDescriptionChange(perguntaIndex: number, eventIndex: number) {
    const eventosArray = this.getEventosArray(perguntaIndex);
    if (!eventosArray) return;

    const control = eventosArray.at(eventIndex);
    if (control.get('descriptionEvent')?.value || !control.get('descriptionEvent')?.value) {
      control.get('eventDate')?.markAsTouched();
      control.get('cid')?.markAsTouched();
      control.get('cpt')?.markAsTouched();
      control.get('displayDs')?.markAsTouched();
      control.get('reason')?.markAsTouched();
    }
  }

  onMostrarEventoColaborador(perguntaIndex: number, resposta: boolean) {
    this.listaDeRespostaDoBeneficiario[perguntaIndex].response = resposta;
    this.listaDeRespostaDoBeneficiario[perguntaIndex].respostaColaborador = true;
    this.mostrarEventoColaborador[perguntaIndex] = resposta;
    this.botoesSelecionados[perguntaIndex] = resposta;
    if (resposta && !this.mostrarEventoColaborador[perguntaIndex]) {
      this.iniciarFormArrayPorPergunta(perguntaIndex);
    }
    this.respostaColaborador(perguntaIndex);
    this.cdr.detectChanges();
  }

  iniciarFormArrayPorPergunta(perguntaIndex: number) {
    if (perguntaIndex) {
      this.formArraysColaborador[perguntaIndex] = this.formBuilder.group({
        events: this.formBuilder.array([]),
      });
    }
    this.cdr.detectChanges();
  }

  getEventosArray(index: number): FormArray | null {
    if (!this.formArraysColaborador[index]) return null;
    return this.formArraysColaborador[index].get('events') as FormArray;
  }

  getControleDeEventos(index: number): AbstractControl[] {
    const eventsArray = this.getEventosArray(index);
    return eventsArray ? eventsArray.controls : [];
  }

  onAdicionarEventoColaborador(index: number): void {
    const eventosArray = this.getEventosArray(index);

    // if (!eventosArray || eventosArray.length >= 4) {
    //   this.toastr.warning('Você já adicionou todos os eventos disponíveis.');
    //   return;
    // }

    const newIndex = eventosArray.length;
    const newEvent = this.criarFormularioEvento();
    eventosArray.push(newEvent);

    if (!this.estadoBotoesCPT[index]) {
      this.estadoBotoesCPT[index] = {};
    }
    this.estadoBotoesCPT[index][newIndex] = null;

    if (!this.estadoBotoesExibirDS[index]) {
      this.estadoBotoesExibirDS[index] = {};
    }
    this.estadoBotoesExibirDS[index][newIndex] = null;

    this.cdr.detectChanges();
  }

  criarFormularioEvento(): FormGroup {
    return this.formBuilder.group({
      eventDate: [null, [Validators.required]],
      cid: [null, [Validators.required, Validators.maxLength(250), Validators.minLength(1)]],
      reason: ['', [Validators.required, Validators.maxLength(250), Validators.minLength(1)]],
      descriptionEvent: ['', [Validators.required, Validators.maxLength(1000), Validators.minLength(1)]],
      displayDs: [null, [Validators.required]],
      cpt: [null, [Validators.required]],
    });
  }

  verificarDuplicidadeEventoColaborador(perguntaIndex: number, eventDate: any, eventIndex: number) {
    const eventosArray = this.getEventosArray(perguntaIndex);
    if (!eventosArray) return;

    const dataDeEventos = eventosArray.controls.map(event => event.get('eventDate')?.value);

    if (eventDate && dataDeEventos.includes(eventDate) && dataDeEventos.indexOf(eventDate) !== eventIndex) {
      this.toastr.warning('Esta data já foi selecionada em outro evento.');

      const eventFormGroup = eventosArray.at(eventIndex) as FormGroup;

      eventFormGroup.reset({
        eventDate: null,
        descriptionEvent: '',
        cid: null,
        reason: '',
        displayDs: null,
        cpt: null,
      });

      if (this.estadoBotoesCPT[perguntaIndex]) {
        this.estadoBotoesCPT[perguntaIndex][eventIndex] = null;
      }
      if (this.estadoBotoesExibirDS[perguntaIndex]) {
        this.estadoBotoesExibirDS[perguntaIndex][eventIndex] = null;
      }

      if (this.listaCidsPorCampo[eventIndex]) {
        this.listaCidsPorCampo[eventIndex] = [];
      }

      eventFormGroup.markAllAsTouched();
      this.cdr.detectChanges();
    }
  }

  removerEventoColaborador(perguntaIndex: number, eventoIndex: number) {
    const eventsArray = this.getEventosArray(perguntaIndex);
    if (eventsArray) {
      eventsArray.removeAt(eventoIndex);
    }
    this.cdr.detectChanges();
  }

  async receberDadosCompartilhadoDependente(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(
        data => {
          this.dadosRecebidos = data && data;
        },
        error => {
          reject(error);
        },
      );
    });
  }

  campoObservacao() {
    if (this.ehTitular) {
      this.adicionarNaListaFinal.emit({
        holderProposalId: this.ehTitular,
        obsGs: this.formPerguntas.controls['obsGs'].value,
      });
    } else {
      this.adicionarNaListaFinal.emit({
        dependentProposalId: this.ehDependente,
        obsGs: this.formPerguntas.controls['obsGs'].value,
      });
    }
  }

  respostaColaboradorTermo() {
    this.itemTermo.optionForPreExistingIllnesses = this.formPerguntas.controls['optionForPreExistingIllnesses'].value;
    this.adicionarNaListaFinal.emit(this.itemTermo);
  }

  respostaColaborador(perguntaIndex: number) {
    if (this.listaDeRespostaDoBeneficiario[perguntaIndex].codeQuestion == 27) {
      this.listaDeRespostaDoBeneficiario[perguntaIndex].height = Number(this.formPerguntas.controls['height'].value);
    } else if (this.listaDeRespostaDoBeneficiario[perguntaIndex].codeQuestion == 28) {
      this.listaDeRespostaDoBeneficiario[perguntaIndex].weight = Number(this.formPerguntas.controls['weight'].value);
      this.listaDeRespostaDoBeneficiario[perguntaIndex].imc = Number(this.imc);
    }

    this.adicionarNaListaFinal.emit(this.listaDeRespostaDoBeneficiario[perguntaIndex]);
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  async receberPerguntasRetornoDS(retornoPerguntas?: any) {
    this.iniciarSpinner();
    this.retornoDS = false;
    try {
      this.formPerguntas.get('response')?.disable();
      this.perguntasDeclaracaoSaude = [];
      this.buscarPerguntas();
      this.formPerguntas.reset();
      this.currentQuestionIndex = 0;
      this.imc = null;
      this.PesoEAltura = false;
      this.ehAltura = false;
      this.ehPeso = false;
      this.mostrarEvento = false;
      this.ehIMC = false;
      this.respostasRetornadasDS = retornoPerguntas;

      let codequestionPerguntas: number[] = this.respostasRetornadasDS.map(item => item.codeQuestion);
      this.perguntasDeclaracaoSaude = this.perguntasDeclaracaoSaude.filter(pergunta => {
        return codequestionPerguntas.includes(pergunta.codeQuestion);
      });

      if (this.currentQuestionIndex >= this.respostasRetornadasDS.length - 1) {
        this.concluirRetornoDS.emit(true);
      }

      this.preencherPerguntaRetornada(0);

      this.cdr.detectChanges();
      this.pararSpinner(500);
    } catch (error) {
      this.pararSpinner(500);
    }
  }

  proximaPerguntaRetornoDS() {
    this.iniciarSpinner();
    this.currentQuestionIndex++;

    if (this.currentQuestionIndex >= this.respostasRetornadasDS.length) {
      this.concluirRetornoDS.emit(true);
      this.pararSpinner();
      return;
    }
    if (this.currentQuestionIndex >= this.respostasRetornadasDS.length - 1) {
      this.concluirRetornoDS.emit(true);
    }

    this.preencherPerguntaRetornada();

    this.gotoTop();
    this.cdr.detectChanges();
    this.pararSpinner(500);
  }

  getEventosRetornoDS(): any[] {
    if (!this.respostasRetornadasDS || this.currentQuestionIndex >= this.respostasRetornadasDS.length) {
      return [];
    }

    const respostaAtual = this.respostasRetornadasDS[this.currentQuestionIndex];
    const eventos = [];

    for (let i = 1; i <= 5; i++) {
      if (respostaAtual[`eventDate${i}`] && respostaAtual[`descriptionEvent${i}`]) {
        eventos.push({
          eventDate: respostaAtual[`eventDate${i}`],
          descriptionEvent: respostaAtual[`descriptionEvent${i}`],
          cid: respostaAtual[`cid${i}`],
          cpt: respostaAtual[`cpt${i}`],
          reason: respostaAtual[`reason${i}`],
          displayDs: respostaAtual[`displayDs${i}`],
        });
      }
    }

    return eventos;
  }

  gotoTop() {
    this._scrollService.scrollToElement('#top-form', 140);
    this._scrollService.setStyle('#top-form', {
      'margin-top': '-141px !important',
    });
  }

  voltarPerguntaRetornoDS() {
    this.iniciarSpinner();

    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
      this.preencherPerguntaRetornada();
      this.cdr.detectChanges();
    }
    this.gotoTop();
    this.cdr.detectChanges();

    this.pararSpinner(500);
  }

  preencherPerguntaRetornada(indexPergunta?: number) {
    const respostaAtual = this.respostasRetornadasDS[indexPergunta || this.currentQuestionIndex];
    this.nome = (respostaAtual && respostaAtual?.beneficiary) || '';
    this.formPerguntas.patchValue({response: respostaAtual.response});

    const perguntaEncontrada =
      this.perguntasDeclaracaoSaude &&
      this.perguntasDeclaracaoSaude?.find(pergunta => pergunta.codeQuestion === respostaAtual.codeQuestion);

    if (perguntaEncontrada) {
      this.textoDaPergunta = perguntaEncontrada.questionText;
      this.imgDaPergunta = perguntaEncontrada.iconPath;
      this.descricaoDaPergunta = perguntaEncontrada.description;
      this.indexDaListaDePerguntas = this.perguntasDeclaracaoSaude.indexOf(perguntaEncontrada) + 1;
    }

    this.limparFormArray(this.listaEventos);
    const eventos = this.getEventosRetornoDS();
    eventos?.forEach(evento => {
      this.listaEventos.push(
        this.formBuilder.group({
          eventDate: [evento.eventDate, Validators.required],
          descriptionEvent: [evento.descriptionEvent, Validators.required],
          cid: [evento.cid],
          cpt: [evento.cpt],
          reason: [evento.reason],
          displayDs: [evento.displayDs],
        }),
      );
    });
  }

  erroSentry(tituloErro: any, erro: any, mensagemErro: any, data: any) {
    this._errorLogging.logError(mensagemErro, data, {
      contexto: tituloErro,
      data: data,
    });
  }

  permitirNumeroVirgulaPonto(event: Event): void {
    const input = event.target as HTMLInputElement;

    // remove tudo que NÃO for número, vírgula ou ponto
    input.value = input.value.replace(/[^0-9.,]/g, '');

    // atualiza o formControl
    this.formPerguntas.get('weight')?.setValue(input.value, {emitEvent: false});
  }

  get descricaoTipoProposta() {
    return TipoPropostaEnumDescription.getDescricao(this.tipoProposta);
  }
}
